"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRewardWinnerDetailsSection = void 0;
const useCreatorGiveaways_1 = require("root/src/client/web/giveaway/hooks/useCreatorGiveaways");
const useUser_1 = require("root/src/client/logic/userData/hooks/useUser");
const rewards_api_contract_1 = require("@daredrop-com/rewards-api-contract");
const useStore_1 = require("root/src/client/logic/helpers/useStore");
const displayNameSelector_1 = __importDefault(require("root/src/client/logic/creatorData/selectors/displayNameSelector"));
const useRewardWinnerDetailsSection = () => {
    var _a, _b, _c;
    const userVouchers = (0, useCreatorGiveaways_1.useUserVouchers)();
    const userAuthentication = (0, useUser_1.useUserAuthentication)();
    const resolvedGiveaway = (0, useCreatorGiveaways_1.useCreatorResolvedGiveaway)();
    const creatorName = (0, useStore_1.useAppSelector)(displayNameSelector_1.default);
    const winner = (_b = (_a = resolvedGiveaway === null || resolvedGiveaway === void 0 ? void 0 : resolvedGiveaway.vouchers) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.owner;
    const awardClaimed = (_c = resolvedGiveaway === null || resolvedGiveaway === void 0 ? void 0 : resolvedGiveaway.vouchers) === null || _c === void 0 ? void 0 : _c.find(voucher => voucher.status === rewards_api_contract_1.VoucherStatus.Used);
    return {
        isUserWinner: (winner === null || winner === void 0 ? void 0 : winner.id) === (userAuthentication === null || userAuthentication === void 0 ? void 0 : userAuthentication.userId),
        awardClaimed,
        winnerName: winner === null || winner === void 0 ? void 0 : winner.name,
        userVouchers,
        giveaway: resolvedGiveaway,
        creatorName,
    };
};
exports.useRewardWinnerDetailsSection = useRewardWinnerDetailsSection;
